import styled from '@emotion/styled';
import { ThemeStyle } from 'assets/scss/common/theme';


export const Wrapper = styled.div`
  min-height: 100vh;
`;

export const Main = styled.div`
  min-height: calc(100vh - 48px);
  margin-top:48px;
  
  .disabled-layer {
    opacity: 0.5;
    pointer-events: none;
  }

  .hidden-layer {
    display: none;
    opacity: 0;
    transition: display 0s linear 0.33s, opacity 0.33s linear;
  }

  &.visible-layer {
    display: flex;
    opacity: 1;
    transition-delay: 0s;
  }

  .bottom-fixed {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    box-shadow: inset 0px 1px 0px rgb(0 19 37 / 16%);
    background: white;
  }

  .new-msg-card {
    .icon {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }

  .trust-note {
    margin-bottom: 80px;
    .p {
      color: rgba(0, 19, 37, 0.92);
    }
  }
`;

export const AddressFormStyle = styled.div`
  .heading {
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
  }
`;

export const BoxStyle = styled.div`
    background: #FFFFFF;
    border: 1px solid rgba(0, 19, 37, 0.16);
    box-sizing: border-box;
    border-radius: ${({ theme }: ThemeStyle) => theme.borders.radiusPrimary};

    .note-title {
        font-size: 20px;
        line-height: 24px;
        letter-spacing: -0.1px;
        color: #000F1D;
        opacity: 0.92;
    }
    .note-subtitle {
        font-size: 12px;
        line-height: 16px;
        color: rgba(0, 19, 37, 0.64);
    }

    .btn-group {
        .choose-btn {
            align-items: center;
            padding: 10px 16px;
            box-sizing: border-box;
            border-radius: 20px;
            background: #FFFFFF;
            border: 1px solid rgba(0, 19, 37, 0.16);
    
    
            .btn-text {
                font-size: 12px;
                line-height: 16px;
                display: flex;
                font-style: normal;
                font-weight: 600;
                align-items: center;
                letter-spacing: 0.1px;
                color: #D7006C;
                margin: 0px 10px;
                color: rgba(0, 19, 37, 0.92);
            }
           
            &.active {
                background: rgba(232, 0, 113, 0.08);
                border: 1px solid #F55D9C;
                .btn-text {
                    color: #D7006C;
                }
            }
        }
    }

    .note-sub-title {
        color: rgba(0, 19, 37, 0.64);
    }
`;

export const HorizonalSeprator = styled.div`
  width: calc(100% - 40px);
  display: flex;
  align-self: center;
  height: 1px;
  background: rgba(0, 19, 37, 0.08);
  margin: 8px 0 16px 0;
`;

